import type { WithdrawalResponseDto } from '@/lib/models/withdrawalResponseDto';
import { formatCurrency } from '@/lib/format-currency';
import { cn } from '@/lib/utils';
import { payButtonClass } from '@/components/features/Deposit/paymentFormClasses';
import successIcon from '@/assets/v.svg';

interface Props {
  /** The created withdrawal — drives the amount, reference and status lines. */
  result: WithdrawalResponseDto;
  /** Dismiss the flow and return to a reset withdraw form. */
  onDismiss: () => void;
}

/**
 * "Withdraw Complete" step content, shown full-page under the stepper after a
 * withdrawal request is accepted (ARC-150). Leads with the submitted state,
 * then the amount, the email hint, and the request's reference + status.
 */
export function WithdrawSuccess({ result, onDismiss }: Props) {
  return (
    <div className="flex flex-col items-center gap-4 text-center" role="status" aria-live="polite">
      <p className="max-w-[340px] text-[21.6px] leading-[30px] text-ink">
        Your withdrawal request has been <span className="font-semibold text-purple">successfully submitted</span>
      </p>
      <img src={successIcon} alt="" aria-hidden className="h-auto w-[140px] motion-safe:animate-deposit-pop" />
      <p className="text-[45px] font-semibold leading-tight tracking-tight text-ink tabular-nums">
        {formatCurrency(result.amount, result.currency)}
      </p>
      <p className="text-[18px] leading-[24px] text-ink">Please check your email for payment updates</p>
      <div className="flex flex-col gap-1">
        <span className="text-[18px] font-semibold text-purple">Reference Number</span>
        <span className="text-[18px] text-ink">{result.id}</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-[18px] font-semibold text-purple">Status</span>
        <span className="text-[18px] capitalize text-ink">{result.status.toLowerCase()}</span>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className={cn(payButtonClass, 'mt-2 h-[50px] w-[270px] text-[21.6px] capitalize')}
      >
        Got It
      </button>
    </div>
  );
}
